/* eslint-disable @typescript-eslint/no-unused-vars */
import ClientResponseProps from 'common/types/UserResponseProps';
import OrderItemProps from 'pages/CreateOrderPage/types/OrderItemProps';
import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as BackIcon } from 'common/icons/return.svg';
import IconButton from 'common/components/IconButton';
import Button from 'common/components/Button';
import { CategoryButton, ContentContainer, OrderInfoSeparator, SidebarCategoryScroller, SidebarCategoryWrapper, SidebarInfoWrapper, SidebarWrapper, StyledListCard } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import CategoryProps from 'pages/CreateOrderPage/types/CategoryProps';
import styled from '@emotion/styled';
import useScreenSize from 'common/hooks/useScreenSize';
import { ParamCardProps, useFetchServiceParams } from 'pages/CreateOrderPage/hooks/useFetchServiceParams';
import Checkbox from 'common/components/Checkbox';
import Pagination from 'common/components/Pagination';
import OrderServiceItem from 'pages/CreateOrderPage/types/OrderServiceItem';
import useSearch from 'common/hooks/useSearch';
import { ReactComponent as ArrowUp } from 'common/icons/arrow-up.svg';
import { ReactComponent as ArrowDown } from 'common/icons/arrow-down.svg';
import { Radio, Slider, useTheme } from '@mui/material';
import Input from 'common/components/Input';
import TextArea from 'common/components/TextArea';
import { ReactComponent as SaveImageIcon } from '../../icons/save-image.svg';
import { ListContainer } from 'pages/CreateOrderPage/components/ListContainer';
import { useCalculateCardNumber } from 'pages/CreateOrderPage/hooks/useCalculateCardNumber';
import { ReactComponent as CrossIcon } from 'common/icons/plus.svg';
import { TagSearchBarContainer, TagWrapper, Tag } from 'pages/CreateOrderPage/styles/TagStyles';
import OrderProductItem from 'pages/CreateOrderPage/types/OrderProductItem';
import CartButton from 'pages/CreateOrderPage/components/CartButton';

export type FullItem = OrderItemProps & OrderServiceItem & OrderProductItem;

type OrderProductSettingsProps = {
  setStage: (stage: number) => void;
  client: ClientResponseProps | null;
  firm: string;
  priceList: string;
  selectedItem: FullItem;
  setSelectedItem: React.Dispatch<React.SetStateAction<FullItem>>;
  orderId: string | number;
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  addItem?: (item: FullItem) => void;
  itemCount?: number;
};

const categoryList: CategoryProps[] = [
  {
    id: 1,
    name: 'Додаткові послуги',
  },
  {
    id: 2,
    name: 'Вид обробки',
  },
  {
    id: 3,
    name: 'Бренд',
  },
  {
    id: 4,
    name: 'Колір',
  },
  {
    id: 5,
    name: 'Фурнітура та декор',
  },
  {
    id: 6,
    name: 'Дефекти',
  },
  {
    id: 7,
    name: 'Походження плям',
  },
  {
    id: 8,
    name: 'Розміщення плям та дефектів ',
  },
  {
    id: 9,
    name: 'Умови прийому',
  },
  {
    id: 10,
    name: 'Фотофіксація',
  },
  {
    id: 11,
    name: 'Інше',
  },
];
// Розмір, Колір, Матеріал, Форма, Покриття, Інше
const productCategoryList: CategoryProps[] = [
  {
    id: 1,
    name: 'Розмір',
  },
  {
    id: 2,
    name: 'Колір',
  },
  {
    id: 3,
    name: 'Матеріал',
  },
  {
    id: 4,
    name: 'Форма',
  },
  {
    id: 5,
    name: 'Покриття',
  },
  {
    id: 6,
    name: 'Інше',
  },
];

const ListCardColor = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  margin-left: auto;
`;

const ListCard = ({ id, name, cardWidth, selectedItem, varName, onClick, type, color }: { color?:string; id: string | number; name: string; cardWidth: number; varName: string, selectedItem: FullItem, onClick: (varName: string, id: string | number) => void; type?: string }) => {
  // check if item is selected in selectedItem[varName] that is an array of ids
  let tempColor = '';
  switch (color) {
    case '7d19acd6-f84e-41ee-b8bb-67edcc3dcde7' : 
      tempColor = 'red';
      break;
    case 'af05c9ab-70ce-4bbe-a257-6a216954cd51':
      tempColor = 'green';
      break;
    case '28f8842f-4b21-4746-83e7-92fe7e6d2259':
      tempColor = 'blue';
      break;
  }
  console.log('color', color);
  let selected;
  if (varName !== 'clothesGender' && varName !== 'marking' && varName !== 'productSizeId') selected = selectedItem[varName] && selectedItem[varName].includes(id);
  else selected = selectedItem[varName] === id;
  return (
    <StyledListCard onClick={() => { onClick(varName, id); }} cardWidth={cardWidth} className={selected ? 'active' : ''}>
      {type === 'radio' ? <Radio onChange={() => { onClick(varName, id); }} checked={selected} /> : <Checkbox onChange={() => { onClick(varName, id); }} checked={selected} />}
      <p>{name}</p>
      {color && <ListCardColor style={{ backgroundColor: tempColor }}></ListCardColor>}
    </StyledListCard>
  );
};

type TagSearchBarProps = {
  value: string,
  onChange: (value: string) => void,
  selected: string[],
  setSelected: (selected: string[]) => void,
  list: ParamCardProps[],
  varName: string,
};

const StyledInput = styled.input`
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    letter-spacing: 1px;
    flex: 1 0 auto;
    border: none;
    outline: none;
    background: transparent;
    &::placeholder {
        color: ${({ theme }) => theme.colors.gray};
    }
`;

const TagSearchBar = ({ value, onChange, selected, varName, setSelected, list }: TagSearchBarProps) => {
  const tagWrapperRef = useRef(null);
  const [scrollInterval, setScrollInterval] = useState(null);

  const scrollTagWrapper = (direction) => {
    const scrollAmount = 2; // Adjust the scroll amount as needed
    const tagWrapper = tagWrapperRef.current;

    if (tagWrapper) {
      if (direction === 'up') {
        tagWrapper.scrollTop -= scrollAmount;
      } else if (direction === 'down') {
        tagWrapper.scrollTop += scrollAmount;
      }
    }
  };

  const startScrolling = (direction) => {
    const interval = setInterval(() => {
      scrollTagWrapper(direction);
    }, 10); // Adjust the interval as needed

    setScrollInterval(interval);
  };

  const stopScrolling = () => {
    clearInterval(scrollInterval);
  };

  const handleArrowDownMouseDown = () => {
    startScrolling('down');
  };

  const handleArrowUpMouseDown = () => {
    startScrolling('up');
  };

  const handleArrowMouseUp = () => {
    stopScrolling();
  };

  const handleDeleteTag = (id: string | number) => {
    setSelected(selected.filter((item) => item !== id));
  };

  return (
    <div className='order-tag-searchbar-line'>
      <TagSearchBarContainer>
        <TagWrapper ref={tagWrapperRef}>
          {selected.map((item, index) => (
            <Tag key={index}>
              {list.find((listItem) => listItem.id === item)?.name}
              <div onClick={() => { handleDeleteTag(item); }} className='order-tag-searchbar-cross'>
                <CrossIcon className='svg-black' />
              </div>
            </Tag>
          ))}
          <StyledInput
            value={value}
            onChange={(e) => { onChange(e.target.value); }}
            placeholder='Пошук...'
          />
        </TagWrapper>
        <div className='order-tag-searchbar-arrow-wrapper'>
          <ArrowUp className='svg-black' onMouseDown={handleArrowUpMouseDown} onMouseUp={handleArrowMouseUp} />
          <ArrowDown className='svg-black' onMouseDown={handleArrowDownMouseDown} onMouseUp={handleArrowMouseUp} />
        </div>
      </TagSearchBarContainer>
    </div>
  );
};

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.gray};
`;

const sliderMarks = [
  {
    value: 0,
    label: '0%',
  },
  {
    value: 25,
    label: '25%',
  },
  {
    value: 50,
    label: '50%',
  },
  {
    value: 75,
    label: '75%',
  },
  {
    value: 100,
    label: '100%',
  },
];

const OrderPhotoContainer = styled.div`
    min-width: 286px;
    height: 200px;
    flex-shrink: 0;
    // .05 opacity
    background-color: ${({ theme }) => theme.colors.primaryColor + '0D'};
    border-radius: 8px;
    padding: 16px;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const OrderPhotoWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    width: 254px;
    height: 136px;
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    & > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
const OrderPhotoCommentWrapper = styled.div`
    height: 32px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    width: 254px;
    display:flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    background-color: ${({ theme }) => theme.colors.backgroundColor};
`;
const OrderPhotoComment = styled.input`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 12px */
    letter-spacing: 1px;
    width: 100%;
    &::placeholder {
        color: ${({ theme }) => theme.colors.gray};
    }
`;
const OrderAddPhotoButton = styled.label`
    height: 200px;
    min-width: 286px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.tretiaryBackgroundColor};
    cursor:pointer;
`;

const OrderPhotoCard = ({ id, image, comment, selectedItem, setSelectedItem }: { id: string | number, image: string | ArrayBuffer | File, comment?: string, selectedItem: FullItem, setSelectedItem: React.Dispatch<React.SetStateAction<FullItem>> }) => {
  const handleCommentChange = (value: string) => {
    const attachedPhotos = selectedItem.attachedPhotos.map((photo) => {
      if (photo.id === id) {
        return { ...photo, comment: value };
      }
      return photo;
    });
    setSelectedItem({ ...selectedItem, attachedPhotos });
  };
  const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };
  let finalImage: string;
  // if Arraybuffer convert to base64
  if (image instanceof ArrayBuffer) {
    const base64Flag = 'data:image/jpeg;base64,';
    const imageStr = arrayBufferToBase64(image);
    finalImage = base64Flag + imageStr;
  } else if (image instanceof File) {
    finalImage = URL.createObjectURL(image);
  } else {
    finalImage = image;
  }
  return (
    <OrderPhotoContainer>
      <OrderPhotoWrapper>
        <img src={finalImage} alt='order-photo' />
      </OrderPhotoWrapper>
      <OrderPhotoCommentWrapper>
        <OrderPhotoComment placeholder='Комментар' value={comment} onChange={(e) => { console.log('yo'); handleCommentChange(e.target.value); }} />
      </OrderPhotoCommentWrapper>
    </OrderPhotoContainer>
  );
};

export default function OrderProductSettings({ itemCount, client, orderId, setStage, selectedItem, setSelectedItem, setPageType, addItem }: OrderProductSettingsProps) {
  const [selectedCategory, setSelectedCategory] = useState(1 as string | number);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const theme = useTheme();
  const listRef = useRef(null);
  const photoListRef = useRef(null);
  const { height, width } = useScreenSize();
  const { searchValue, onSearchChange, clearSearch } = useSearch();
  const handleCategoryClick = (id: string | number) => {
    clearSearch();
    setSelectedCategory(id);
  };
  const { cardLineCount, itemList, searchedList, isSearch, varName, isCustom, photoList } = useFetchServiceParams(selectedCategory, searchValue, selectedItem, refresh);
  const [cardWidth, setCardWidth] = useState(100);
  useEffect(() => {
    if (listRef.current) {
      //const listWidth = (listRef.current as unknown as HTMLDivElement).offsetWidth;
      setCardWidth((840 / cardLineCount) - 32);
    }
  }, [listRef, height, width, cardLineCount]);

  // filter itemList by searchValue


  const { shownList, cardCount, pageCount, shownPhotoList } = useCalculateCardNumber(selectedCategory, searchedList, selectedCategory === 10 ? photoListRef : listRef, cardWidth, page, setPage, height, width, selectedCategory === 10 ? 200 : 72, photoList);
  if (selectedCategory === 10) console.log(shownList);
  const handleCardClick = (varNameInner: string, id: string | number) => {
    console.log(varNameInner);
    if (selectedItem[varNameInner] && selectedItem[varNameInner].includes(id)) {
      setSelectedItem({ ...selectedItem, [varNameInner]: selectedItem[varNameInner].filter((item) => item !== id) });
    } else {
      setSelectedItem({ ...selectedItem, [varNameInner]: [...selectedItem[varNameInner], id] });
    }
  };

  console.log(`VarName: ${varName}`);

  return (
    <div className='order-content-container'>
      <div className='order-top-line'>
        <div className='order-top-line-client-wrapper'>
          <p>Клієнт:</p>
          <p className='basic-link' onClick={() => { setStage(1); }}>{client && `${client.lastName} ${client.firstName[0]}.${client.patronymic ? client.patronymic[0] + '.' : ''}`}</p>
        </div>
        <div className='order-top-line-button-wrapper'>
          <IconButton onClick={() => { setSelectedItem(null); clearSearch(); }}>
            <BackIcon className='svg-black svg-fill' />
          </IconButton>
          <CartButton itemCount={itemCount} setPageType={setPageType} type='cart' />
        </div>
      </div>
      <div className='order-product-settings-wrapper'>
        <div className='order-product-absolute-wrapper'>
          <SidebarWrapper>
            <SidebarCategoryWrapper>
              <SidebarCategoryScroller>
                <h3 className='new-h3 order-category-title'>Параметри</h3>
                {selectedItem.type === 'service' ? categoryList.map((category) => (
                  <CategoryButton
                    key={category.id}
                    onClick={() => handleCategoryClick(category.id)}
                    className={selectedCategory === category.id ? 'active' : ''}
                  >
                    {category.name}
                  </CategoryButton>
                )) :
                  productCategoryList.map((category) => (
                    <CategoryButton
                      key={category.id}
                      onClick={() => handleCategoryClick(category.id)}
                      className={selectedCategory === category.id ? 'active' : ''}
                    >
                      {category.name}
                    </CategoryButton>
                  ))
                }
              </SidebarCategoryScroller>
            </SidebarCategoryWrapper>
            <SidebarInfoWrapper>
              <h3 className='new-h3 order-category-title find-client-info-title'>Інформація про послугу</h3>
              <div className='find-client-info-list u-fancy-scrollbar'>
                <div className='find-client-info-line'>
                  <p className='find-client-info-line-title'>№ замовлення</p>
                  <p className='find-client-info-line-value'>{`№${orderId}`}</p>
                </div>
                {selectedItem.categoryName && <div className='find-client-info-line'>
                  <p className='find-client-info-line-title'>Категорія</p>
                  <p className='find-client-info-line-value'>
                    {selectedItem.categoryName}
                  </p>
                </div>}
                {selectedItem.name && (
                  <div className='find-client-info-line'>
                    <p className='find-client-info-line-title'>{selectedItem.type === 'service' ? 'Вид одягу' : 'Вид товару'}</p>
                    <p className='find-client-info-line-value'>{selectedItem.name}</p>
                  </div>
                )}
              </div>
              <div className='order-info-price-wrapper'>
                <OrderInfoSeparator />
                <div className='order-info-price-line'>
                  <span className='order-infor-price-title'>Ціна</span>
                  <span className='order-infor-price-title'>{selectedItem.price ? selectedItem.price.toFixed(2) : '0.00'} ₴</span>
                </div>
              </div>
            </SidebarInfoWrapper>
          </SidebarWrapper>
          <ContentContainer>
            <div className='find-client-top-line'>
              <span className='big-text'>
                {selectedItem.type === 'service' && selectedCategory && categoryList.find((category) => category.id === selectedCategory)?.name}
                {selectedItem.type === 'product' && selectedCategory && productCategoryList.find((category) => category.id === selectedCategory)?.name}
              </span>
              <span className='order-subtext gray-text'>

              </span>
            </div>
            {!isCustom && <>
              {isSearch && <TagSearchBar
                value={searchValue}
                onChange={onSearchChange}
                selected={selectedItem[varName] || []}
                varName={varName}
                setSelected={(selected) => { setSelectedItem({ ...selectedItem, [varName]: selected }); }}
                list={itemList}
              />}
              <ListContainer listRef={listRef} cardWidth={cardWidth}>
                {shownList.map((item) => (
                  <ListCard
                    key={item.id}
                    id={item.id}
                    name={item.name}
                    cardWidth={cardWidth}
                    selectedItem={selectedItem}
                    varName={varName}
                    onClick={handleCardClick}
                    color={(varName === 'colorsId' || varName === 'productColorsId') && item.id}
                  />
                ))}
              </ListContainer>
              <div className='order-pagination-wrapper'>
                {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
              </div>
              {selectedItem.type === 'service' && selectedCategory === 6 &&
                <div className='order-defect-slider-wrapper'>
                  <Separator />
                  <span className='order-defect-title'>
                    Знос у відсотках (%)
                  </span>
                  <div className='order-defect-slider-line'>
                    <Slider
                      step={25}
                      min={0}
                      max={100}
                      value={selectedItem.defectsSlider || 0}
                      onChange={(e, value) => { setSelectedItem({ ...selectedItem, defectsSlider: value as number }); }}
                      marks={sliderMarks}
                      sx={{
                        '& .MuiSlider-rail': {
                          color: theme.colors.gray,
                        },
                        '& .MuiSlider-mark': {
                          height: 8,
                          width: 8,
                          borderRadius: '50%',
                          backgroundColor: '#D9D9D9',
                          transform: 'translate(-50%, -50%)',
                        },
                        '& .MuiSlider-markActive': {
                          opacity: 1,
                          backgroundColor: 'currentColor',
                        },
                        '& .MuiSlider-markLabel': {
                          fontSize: 16,
                          fontStyle: 'normal',
                          fontWeight: 500,
                          lineHeight: '100%',
                          letterSpacing: 1,
                        },
                      }}
                    />
                  </div>
                </div>
              }
            </>
            }
            {selectedItem.type === 'service' && isCustom && selectedCategory === 10 &&
              <>
                <div className='order-photo-list-wrapper'>
                  <div ref={photoListRef} className='order-photo-list'>
                    {shownPhotoList.map((photo, index) => (
                      <OrderPhotoCard key={index} id={photo.id} image={photo.photo} comment={photo.comment} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
                    ))}
                    <input type='file' id='file' style={{ display: 'none' }} onChange={(e) => { setSelectedItem({ ...selectedItem, attachedPhotos: [...selectedItem.attachedPhotos, { id: selectedItem.attachedPhotos.length + 1, photo: e.target.files[0], comment: '' }] }); }} />
                    <OrderAddPhotoButton htmlFor='file'>
                      <SaveImageIcon className='svg-black' />
                      <span className='order-add-photo-text'>Додати фото</span>
                    </OrderAddPhotoButton>
                  </div>
                </div>
                <div className='order-pagination-wrapper'>
                  {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
                </div>
              </>
            }
            {selectedItem.type === 'service' && isCustom && selectedCategory === 11 &&
              <div className='order-other-wrapper'>
                <span className='order-other-title'>Стать</span>
                <div className='order-other-double-card'>
                  { /* clothesGender: 1 = male, 2 = female */}
                  <ListCard
                    cardWidth={200}
                    id={1}
                    name='Чоловіча'
                    selectedItem={selectedItem}
                    varName={'clothesGender'}
                    onClick={() => { setSelectedItem({ ...selectedItem, clothesGender: 1 }); }}
                  />
                  <ListCard
                    cardWidth={200}
                    id={2}
                    name='Жіноча'
                    selectedItem={selectedItem}
                    varName={'clothesGender'}
                    onClick={() => { setSelectedItem({ ...selectedItem, clothesGender: 2 }); }}
                  />
                </div>
                <span className='order-other-title'>Маркування</span>
                <div className='order-other-double-card'>
                  <ListCard
                    cardWidth={200}
                    id={1}
                    name='Маркування вітсутнє. Прийнято за бажанням клієнта'
                    selectedItem={selectedItem}
                    varName={'marking'}
                    onClick={() => { setSelectedItem({ ...selectedItem, marking: 1 }); }}
                  />
                  <ListCard
                    cardWidth={200}
                    id={2}
                    name='Усі види обробки заборонені. Прийнято за бажанням клієнта'
                    selectedItem={selectedItem}
                    varName={'marking'}
                    onClick={() => { setSelectedItem({ ...selectedItem, marking: 2 }); }}
                  />
                </div>
                <span className='order-subtext order-other-subtext'>Примітка до ярлику / Лінійні розміри</span>
                <Input
                  value={selectedItem.stickingLabel}
                  onChange={(e) => { setSelectedItem({ ...selectedItem, stickingLabel: e.target.value }); }}
                  placeholder='Введіть примітку для ярлику / лінійний розмір'
                  className='order-other-input'
                />
                <span className='order-subtext order-other-subtext'>Комментар</span>
                <TextArea
                  value={selectedItem.comment}
                  onChange={(e) => { setSelectedItem({ ...selectedItem, comment: e.target.value }); }}
                  placeholder='Опишіть важливу інформацію'
                  height={'84px'}
                />
              </div>
            }
            {selectedItem.type === 'product' && isCustom && selectedCategory === 1 && <>
              <ListContainer listRef={listRef} cardWidth={cardWidth}>
                {shownList.map((item) => (
                  <ListCard
                    key={item.id}
                    id={item.id}
                    name={item.name}
                    cardWidth={cardWidth}
                    selectedItem={selectedItem}
                    varName={varName}
                    onClick={() => { setSelectedItem({ ...selectedItem, productSizeId: item.id }); }}
                    type='radio'
                  />
                ))}
              </ListContainer>
              <div className='order-pagination-wrapper'>
                {pageCount >= 2 && <Pagination count={pageCount} page={page} setPage={setPage} />}
              </div>
            </>}
            {selectedItem.type === 'product' && isCustom && selectedCategory === 6 && <>
              <div className='order-other-wrapper'>
                  <span className='order-subtext order-other-subtext'>Кількість</span>
                  <div className='order-other-count-wrapper order-other-input'>
                    <Input
                      value={selectedItem.count.toString()}
                      props={{ type: 'number' }}
                      onChange={(e) => { setSelectedItem({ ...selectedItem, count: parseInt(e.target.value) }); }}
                      placeholder='Введіть кількість'
                    />
                    <div className='order-other-count-buttons'>
                      <ArrowUp className='svg-black' onClick={() => { setSelectedItem({ ...selectedItem, count: selectedItem.count + 1 || 1 }); }} />
                      <ArrowDown className='svg-black' onClick={() => { setSelectedItem({ ...selectedItem, count: selectedItem.count >= 1 && selectedItem.count - 1 || 1 }); }} />
                    </div>
                  </div>
                  <span className='order-subtext order-other-subtext'>Комментар</span>
                  <TextArea
                    value={selectedItem.description}
                    onChange={(e) => { setSelectedItem({ ...selectedItem, description: e.target.value }); }}
                    placeholder='Опишіть важливу інформацію'
                    height={'84px'}
                  />
              </div>
            </>}
          </ContentContainer>
        </div>
      </div>
      <div className='order-product-button-wrapper'>
        <Button disabled label='У чернетку' />
        <Button disabled={!client} primary onClick={() => { addItem(selectedItem); }} label='Додати послугу' />
      </div>
    </div>
  );
}